package org.example.zone360.components

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CancelSubscription(
    val subscriptionId: String = "",
    val status: String = "",
    val cancel_at_period_end: Boolean = false
)

@Serializable
data class CancelSubscriptionRequest(
    val subscriptionId: String
)